import React from 'react';
import './workflow-feedback.css';

export function WorkflowAlert({ message, onClose, title = 'Something needs attention' }) {
  if (!message) return null;
  return (
    <div className="workflow-alert-backdrop" role="presentation" onPointerDown={event => { if (event.target === event.currentTarget) onClose?.(); }}>
      <section className="workflow-alert" role="alertdialog" aria-modal="true" aria-labelledby="workflow-alert-title" aria-describedby="workflow-alert-message">
        <div className="workflow-alert-icon" aria-hidden="true">!</div>
        <h2 id="workflow-alert-title">{title}</h2>
        <p id="workflow-alert-message">{message}</p>
        <button type="button" className="tracking-btn tracking-btn-primary" onClick={onClose}>Got it</button>
      </section>
    </div>
  );
}

export function WorkflowComplete({ eyebrow, title, summary, details = [], notice, primaryLabel = 'Back to Deployment Manager', onPrimary, secondaryLabel, onSecondary }) {
  return (
    <section className="workflow-complete" aria-live="polite">
      <div className="workflow-complete-icon" aria-hidden="true">✓</div>
      {eyebrow && <div className="workflow-complete-eyebrow">{eyebrow}</div>}
      <h2>{title}</h2>
      {summary && <p className="workflow-complete-summary">{summary}</p>}

      {details.length > 0 && (
        <div className="workflow-complete-details">
          {details.map((detail, index) => (
            <div key={`${detail.label}-${index}`}>
              <span>{detail.label}</span>
              <strong>{detail.value}</strong>
            </div>
          ))}
        </div>
      )}

      {notice && <div className="workflow-complete-notice">{notice}</div>}

      <div className="workflow-complete-actions">
        <button type="button" className="tracking-btn tracking-btn-primary" onClick={onPrimary}>{primaryLabel}</button>
        {secondaryLabel && onSecondary && (
          <button type="button" className="tracking-btn tracking-btn-secondary" onClick={onSecondary}>{secondaryLabel}</button>
        )}
      </div>
    </section>
  );
}
